const copyCupomHeader = () =>  { 
    let button = $('header .rnk-btn-copy');
    $(button).on('click', (e) => {
        let buttonTarget = e.target;
        let textToCopy = $(buttonTarget).find('.rnk-codigo-cupom').text();      
        navigator.clipboard.writeText(textToCopy);
    })
    
    
    adicionarClassCupomHeader(); 
};

const adicionarClassCupomHeader = () => {
    if($('.rnk-btn-header-cupom').length > 0) {
        $('main').addClass('rnk-header-copy-cupom');
    } 
}

copyCupomHeader();

export default{};